import { buildR2AssetsImageUrl } from "@saas/shared/lib/image-url-builder";
import type { ZombieTrendQualityId } from "./zombie-trend-preset";

export interface ZombieTrendShowcaseClip {
	id: string;
	quality?: ZombieTrendQualityId;
	orientation: "landscape" | "portrait";
	onSite: boolean;
	duration: number;
	videoUrl: string;
	poster: string;
	hasAudio: boolean;
	inputImages?: [string, string];
	/** External clips: where the clip came from (kept for our records, not shown on the page) */
	source?: string;
}

const R2_BASE = "home/showcase/zombie-trend";

/**
 * Six third-party trend references, none generated here (onSite: false, no VideoObject).
 * Array order is column by column: the grid fills three columns of two.
 */
export const zombieTrendShowcaseClips: ZombieTrendShowcaseClip[] = [
	{
		id: "zombieaitrend-cabin-meadow",
		source: "zombieaitrend.com",
		orientation: "landscape",
		onSite: false,
		duration: 25,
		videoUrl: buildR2AssetsImageUrl(
			`${R2_BASE}/clips/zombieaitrend-cabin-meadow.mp4?v=1`,
		),
		poster: buildR2AssetsImageUrl(
			`${R2_BASE}/posters/zombieaitrend-cabin-meadow.jpg`,
		),
		hasAudio: true,
	},
	{
		id: "facebook-mountain-memory",
		source: "Facebook",
		orientation: "landscape",
		onSite: false,
		duration: 28,
		videoUrl: buildR2AssetsImageUrl(
			`${R2_BASE}/clips/facebook-mountain-memory.mp4?v=1`,
		),
		poster: buildR2AssetsImageUrl(
			`${R2_BASE}/posters/facebook-mountain-memory.jpg`,
		),
		hasAudio: true,
	},
	{
		id: "mediaio-kitchen-reunion",
		source: "media.io",
		orientation: "landscape",
		onSite: false,
		duration: 20,
		videoUrl: buildR2AssetsImageUrl(
			`${R2_BASE}/clips/mediaio-kitchen-reunion.mp4?v=1`,
		),
		poster: buildR2AssetsImageUrl(
			`${R2_BASE}/posters/mediaio-kitchen-reunion.jpg`,
		),
		hasAudio: true,
	},
	{
		id: "mediaio-school-uniform",
		source: "media.io",
		orientation: "landscape",
		onSite: false,
		duration: 21,
		videoUrl: buildR2AssetsImageUrl(
			`${R2_BASE}/clips/mediaio-school-uniform.mp4?v=1`,
		),
		poster: buildR2AssetsImageUrl(
			`${R2_BASE}/posters/mediaio-school-uniform.jpg`,
		),
		hasAudio: true,
	},
	{
		id: "aizombie-wheat-field",
		source: "aizombie.video",
		orientation: "landscape",
		onSite: false,
		duration: 15,
		videoUrl: buildR2AssetsImageUrl(
			`${R2_BASE}/clips/aizombie-wheat-field.mp4?v=1`,
		),
		poster: buildR2AssetsImageUrl(
			`${R2_BASE}/posters/aizombie-wheat-field.jpg`,
		),
		hasAudio: true,
	},
	{
		id: "mediaio-field-jacket",
		source: "media.io",
		orientation: "landscape",
		onSite: false,
		duration: 21,
		videoUrl: buildR2AssetsImageUrl(
			`${R2_BASE}/clips/mediaio-field-jacket.mp4?v=1`,
		),
		poster: buildR2AssetsImageUrl(
			`${R2_BASE}/posters/mediaio-field-jacket.jpg`,
		),
		hasAudio: true,
	},
];

export const ZOMBIE_TREND_SHOWCASE_UPLOADED_AT = "2026-10-10T00:00:00+08:00";
